import { useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useColorScheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import Unlocked from '@gef-ui/components/atoms/SvgIcon/Icons/Unlocked';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { subheaders } from 'features/common/Subheader/constants';
import { setVisibleState } from 'features/common/Subheader/slice';
import contactReleasing from 'features/views/campaignManagement/contactReleasing';
import { resetOtherSidebarFields } from 'features/views/campaignManagement/sidebar/actions';

const { processes } = contactReleasing.constants;

const SidebarContactReleaseNew = () => {
	const dispatch = useDispatch();
	const { mode: appTheme } = useColorScheme();

	const selectedProcess = useSelector(contactReleasing.selectors.getSelectedProcess);
	const selected = selectedProcess === processes.CONTACT_RELEASE;

	const handleToggleProcess = useCallback(() => {
		!selected &&
			dispatch(setVisibleState({ id: subheaders.campaignManagementSidebarManualAssign, visible: false }));
		dispatch(
			contactReleasing.actions.setProcess({
				process: selected ? null : processes.CONTACT_RELEASE,
			}),
		);
		dispatch(resetOtherSidebarFields(processes.CONTACT_RELEASE));
	}, [dispatch, selected]);

	return (
		<Stack
			sx={{
				cursor: 'pointer',
				border: '1px solid',
				borderColor: 'lightgrey',
				borderRadius: '4px',
				height: '40px',

				backgroundColor: (theme) =>
					appTheme === 'light'
						? selected
							? 'primary.shades.8p'
							: theme.palette.common.white
						: selected
						  ? 'primary.shades.30p'
						  : theme.palette.background[300],

				':hover': {
					borderColor: 'common.black',
				},

				alignItems: 'center',
			}}
			direction="row"
			onClick={handleToggleProcess}
		>
			<IconButton sx={{ fontSize: '15px', color: 'info.main', ml: 0.5, mr: 1 }} disableRipple>
				<Unlocked />
			</IconButton>
			<Typography
				sx={{
					fontSize: '1rem',
					color: (theme) =>
						appTheme === 'light'
							? selected
								? theme.palette.text.primary
								: theme.palette.grey[600]
							: selected
							  ? theme.palette.text.primary
							  : theme.palette.grey[300],
					fontWeight: 400,
				}}
			>
				{getLabelMessage('campaignManagement:contactRelease')}
			</Typography>
		</Stack>
	);
};

export default SidebarContactReleaseNew;
